export const main = {
    login:'登录',
    register:'注册',
    sy: '首页',
    cpzx: "产品中心",
    jjfa: "视觉案例",
    hyyy: "应用领域",
    fwyzc: "服务与支持",
    gywm: "关于我们",
    xlwjxj: "KJ-W3D系列工业级相机",
    ljkzq: "KJ-Vision-ER控制器",
    sjkzq: "KJ-Vision视觉控制器",
    sdxxrj: "KJ-Vision-Ai深度学习软件",
    sjjcpt: "KJ-Vision-3D视觉检测软件",
    sjcl: "3D引导视觉案例",
    sjjc: "2D视觉案例",
    bzsjrj: "KJ-Vision标准视觉软件",
    sjyd: "3D线扫视觉案例",
    jcsb: "深度学习视觉案例",
    jcsb3D: "3D检测设备",
    xnyld: '新能源锂电池与光伏',
    wl:"物流",
    qcyzdh:'汽车与自动化',
    fzy:'纺织业',
    cpsc:'产品手册',
    gsjs:'公司简介',
    lxwm:'联系我们',

}
